export type LibraryContentType = 'character' | 'world' | 'movie' | 'comic' | 'poster' | 'shot_batch' | 'game' | 'audio' | 'model_3d';
export type LibraryStatus = 'nominated' | 'review' | 'published' | 'archived';
export type LibraryVisibility = 'organization' | 'community' | 'public';
export type LibrarySourceType = 'student_creation' | 'teacher_submission' | 'admin_upload' | 'legacy_showdown';

export interface LibraryItem {
  id: string;
  status: LibraryStatus;
  contentType: LibraryContentType;
  title: string;
  description: string;
  displayAssetUrl: string;
  originalAssetUrl?: string;
  model3d?: { mediaType: 'image' | 'video' };
  game?: { url: string; embedUrl?: string };
  shotBatch?: { videos: { id: string; url: string; title: string; posterUrl?: string }[] };
  visibility: LibraryVisibility;
  gameEligible: boolean;
  featured: boolean;
  collectibleNumber?: number;
  defaultsVersion?: number;
  sourceType: LibrarySourceType;
  sourcePortfolioCreationId?: string;
  sourcePortfolioEntryId?: string;
  sourceLesson?: { sessionId: string; levelId: string; slotIndex?: number; date?: string };
  previewAssetUrl?: string;
  squadId?: string;
  squadName?: string;
  schoolLogoUrl?: string;
  curriculumId?: string;
  curriculumLabel?: string;
  teamId?: string;
  teamName?: string;
  teamLogoUrl?: string;
  attribution?: 'team_and_squad' | 'team' | 'overture_students' | 'overture' | 'none';
  tags?: string[];
  character?: {
    artwork?: {
      mode: 'original' | 'custom';
      customUrl?: string;
      originalPosition?: { x: number; y: number; zoom: number };
      customPosition?: { x: number; y: number; zoom: number };
    };
    traits?: string[];
    colors?: string[];
    wears?: string;
    carries?: string;
    detail?: string;
    move?: string;
    ability?: string;
    abilityDescription?: string;
  };
  world?: {
    colors?: string[];
    subtitle?: string;
    vibe?: string;
    features?: string;
    inhabitants?: string;
    happenings?: string;
    landmark?: string;
    rule?: string;
    setting?: string;
    details?: string[];
    obstacle?: string;
    enemyName?: string;
    enemyAction?: string;
    playerMove?: string;
    fitReason?: string;
    sounds?: string;
  };
  movie?: { duration?: string; genre?: string; captionsUrl?: string };
  submittedBy: string;
  reviewedBy?: string;
  publishedBy?: string;
  archivedReason?: string;
  internalNotes?: string;
  createdAt?: any;
  updatedAt?: any;
  publishedAt?: any;
}

export const libraryAttribution = (item: LibraryItem): string => {
  if (item.attribution === 'none') return '';
  if (item.attribution === 'overture') return 'Created by Overture';
  if (item.attribution === 'overture_students') return 'Created by an Overture student team';
  if (item.attribution === 'team' && item.teamName) return `Created by ${item.teamName}`;
  if (item.teamName && item.squadName) return `Created by ${item.teamName} · ${item.squadName}`;
  if (item.teamName) return `Created by ${item.teamName}`;
  if (item.squadName) return `Created by ${item.squadName}`;
  return item.sourceType === 'admin_upload' ? 'Created by Overture' : 'Created by an Overture student team';
};
